class RelatedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    const defaultLabel = this.els.label.element.dataset.default

    this.els.item.elements.forEach((itemEl) => {
      itemEl.addEventListener('mouseover', () => {
        this.label = itemEl.dataset.style
      })

      itemEl.addEventListener('mouseout', () => {
        this.label = defaultLabel
      })
    })
  }

  /**
   * @returns {String}
   */
  get label () {
    return this._label
  }

  /**
   * @param {String} val
   *
   * @returns {void}
   */
  set label (val) {
    this._label = val

    this.els.label.element.innerText = val
  }
}

if (!customElements.get('related-products')) {
  customElements.define('related-products', RelatedProducts)
}
